<template>
  <div class="dialog-address">
    <el-dialog :title="isAdd?'新增寄送地址':'修改寄送地址'"
      :visible.sync="addressDialogVisible"
      :close-on-click-modal="false"
      @close="cancleDialog"
      width="560px" >
      <div>
        <el-form :model="addressDialogForm" label-width="150px" :rules="rules" ref="addressForm">
          <el-form-item label="收件人：" prop="name">
            <el-input v-model="addressDialogForm.name" placeholder="请输入收件人" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item label="选择省：" prop="provinceIndex">
            <el-select  v-model="addressDialogForm.provinceIndex" filterable placeholder="请选择省份" @change="getCityList($event)" size="small" class="pxy-input" value-key="pid">
              <el-option v-for="(item,index) in provinceList" :key="index" :label="item.province" :value="item" ></el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="选择市：" prop="cityIndex">
          <el-select v-model="addressDialogForm.cityIndex" filterable placeholder="请选择城市" size="small" class="pxy-input">
            <el-option v-for="(item,index) in cityList" :key="index" :label="item.city" :value="item.city">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input v-model="addressDialogForm.address" placeholder="请输入详细地址" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="mobile">
            <el-input v-model="addressDialogForm.mobile" placeholder="请输入联系电话" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item label="邮政编码：" prop="zipCode">
            <el-input v-model="addressDialogForm.zipCode" placeholder="请输入邮政编码" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item label="" prop="">
            <el-checkbox v-model="addressDialogForm.defaultFlag" :true-label="1" :false-label="0">设置为默认地址</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submit" v-loading="loading" :disabled="loading" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 设置手机号的验证规则
const phoneRules = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入联系方式'))
  } else {
    const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的电话号码'))
    }
  }
}
const zipCodeRules = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入邮政编码'))
  } else {
    const reg = /^[a-zA-Z0-9 ]{3,12}$/;
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的邮政编码'))
    }
  }
}
export default {
  props: {
    isAdd: {
      type: Boolean,
      default: false
    },
    addressDialogVisibleProps: {
      type: Boolean,
      default: false
    },
    addressRowInfoProps: {
      type: Object,
      default: {}
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    addressDialogVisible: {
      get() {
        return this.addressDialogVisibleProps;
      },
      set() {}
    }
  },
  watch: {
    'addressRowInfoProps': {
      handler(val) {
          this.addressDialogForm = JSON.parse(JSON.stringify(val));
          if(val.provinceIndex) {
            this.provinceList.forEach(item => {
              if(item.province == this.addressDialogForm.provinceIndex) {
                this.addressDialogForm.provinceIndex = item;
                this.getCityList(item);
                this.$set(this.addressDialogForm,'cityIndex',val.cityIndex)
              }
            })
          }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      addressDialogForm: {
        name: '',
        address: '',
        mobile: '',
        zipCode: '',
        defaultFlag: 0, // 0否 1是
        provinceIndex: {},
        cityIndex: '',
        loading: false,
      },
      rules: {
        name: [{required: true, message: '请输入收件人', trigger: 'blur'}],
        address: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
        mobile: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {validator: phoneRules, trigger: 'blur'},
        ],
        zipCode: [{required: true, message: '请输入邮政编码', trigger: 'blur'},
          {validator: zipCodeRules, trigger: 'blur'}],
        provinceIndex: [{required: true, message: '请选择省份', trigger: 'blur'}],
        cityIndex: [{required: true, message: '请选择市', trigger: 'blur'}]
      },
      provinceList: [],
      cityList: []
    }
  },
  mounted() {
    this.getProvinceList();
  },
  methods: {
    cancleDialog() {
      this.$refs.addressForm.resetFields();
      // console.log(this.addressDialogForm,'addressDialogForm')
      this.$emit('cancleAddressDialog')
    },
    submit() {
      this.$refs.addressForm.validate(valid => {
        if(valid) {
          let url = this.isAdd?'/uac/address/add' :'/uac/address/update';
          let params = {
            name: this.addressDialogForm.name,
            address: [this.addressDialogForm.provinceIndex.province,this.addressDialogForm.cityIndex,this.addressDialogForm.address].join(' / '),
            mobile: this.addressDialogForm.mobile,
            zipCode: this.addressDialogForm.zipCode,
            defaultFlag: this.addressDialogForm.defaultFlag, // 0否 1是
            userId: this.user.userId
          }
          if(!this.isAdd) params.id = this.addressDialogForm.id;
          this.loading = true;
          this.postRequestJson(url, params).then(res => {
            this.loading = false;
            if(res.status === 200) {
              if(res.data.code === 1000) {
                 this.$message.success('保存成功！');
                this.cancleDialog();
                this.$refs.addressForm.resetFields();
              } else {
                this.$message.error(res.data.message);
              }
            }
          })
        }
      })
    },
    // 获取省
    getProvinceList(){
      this.getRequest('/uacLocationProvince/getProvinceList').then(resp => {
        if (resp.status == 200) {
          if (resp.data.code == 1000) {
            this.provinceList = resp.data.result;
          } else {
            Message.error(resp.data.message);
          }
        } else {
          console.error("error")
        }
      })
    },
    // 获取市
    getCityList(event){
      // 清空之前选择的市
      this.addressDialogForm.cityIndex = '';
      this.getRequest('/uacLocationCity/getList',{'pid':event.pid}).then(resp => {
        if (resp.status == 200) {
          if (resp.data.code == 1000) {
            this.cityList = resp.data.result;
            // 如果是直辖市，直接默认选择市，不需要用户手动勾选
            if(event.pid <=4) {
              this.addressDialogForm.cityIndex =resp.data.result[0].city
            }
          } else {
            Message.error(resp.data.message);
          }
        } else {
          console.error("error")
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
 .dialog-address{
    .pxy-input {
      width: 220px;
    }
  }
 </style>
